// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b27c08e8","239":"4530f492","732":"d1494206","977":"88c01317"}[chunkId] + ".chunk.js";
};